export class ArrayHelper {
    public static getDistinct<T>(array: T[]) {
        // @ts-ignore
        return array.filter((value, index, self) => {
            return self.indexOf(value) === index;
        });
    }

    public static sortBy<T>(array: T[], asc: boolean, property: (value: T) => any) {
        return array.slice().sort((a, b) => {
            let varA = property(a);
            let varB = property(b);
            if (varA === varB) return 0;
            if (typeof varA === 'string') varA = varA.toUpperCase();
            if (typeof varB === 'string') varB = varB.toUpperCase();
            let comparison = 0;
            if (varA === null) {
                comparison = 1;
            } else if (varB === null) {
                comparison = -1;
            } else if (varA > varB) {
                comparison = 1;
            } else if (varA < varB) {
                comparison = -1;
            }
            return (asc ? comparison : (comparison * -1));
        });
    }
}
